import React from 'react';

import TheInformationLogo from 'images/the-information-logo.svg';

const TIHeader = ({
  newSessionPath,
  currentUserName,
  rootPath,
  newsletterLandingPath,
  newsletterLogo,
  isLoggedIn,
}) => {
  let link;

  if (isLoggedIn) {
    link = <a href={rootPath}>Welcome, {currentUserName}</a>;
  } else {
    link = (
      <a href={newSessionPath} className="sign-in-link">
        Sign In
      </a>
    );
  }

  return (
    <div className="rc-ti-header-wrapper">
      <div className="rc-newsletter-header">
        <div className="ti-logo-wrapper">
          <a href={rootPath}>
            <img src={TheInformationLogo} />
          </a>
        </div>
        <div className="newsletter-logo-wrapper">
          <a href={newsletterLandingPath}>
            <img src={newsletterLogo} />
          </a>
        </div>
        <div className="sign-in">{link}</div>
      </div>
    </div>
  );
};

export default TIHeader;
